export default {
  props: {
    files: FileList,
  },

  watch: {
    files() {},
  },
};
